
const table = `
<tr><td>Australia</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
<p>A mandatory BIC (Bank Identification Code) and a BSB (Bank State Branch) code is required for banks in Australia.  The BSB is a 6 digit number; the first two digits identify the bank, the third the state and the final three digits identify the branch.  Do not input a hyphen in the BSB code.  Where the beneficiary bank is outside Australia (e.g. New Zealand) then a BSB is not required and a BIC and account number will suffice.</br>
<p>In <strong>Gem Connect</strong> populate the following fields:</br></p>
<p><strong>Beneficiary </strong></p>
<p>For all transactions in and out of Australia, including those paid through an intermediary bank, include account number, full name (no initials) and address of the beneficiary customer. Include city, state, country and postal code for the beneficiary customer’s address. P.O. Box numbers are not permitted.</p>
<p><strong>Beneficiary bank </strong></p>
Beneficiary account type = BBAN or Other</br>
Beneficiary account number = Australian 10 digit account number</br>
Beneficiary bank SWIFT BIC = Australian beneficiary bank BIC. SWIFT BIC is 8 or 11 alphanumeric characters: xxxxAUxx or xxxxAUxxxxx</br>
Beneficiary bank code type = AUBSB</br>
Beneficiary bank code = 6 digit BSB code
</p>
</td>
<td>All</td></tr>

<tr><td>Bahrain</td><td>
<strong>Beneficiary</strong>
<p>
<p>Include full name (no initials) and address of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary.<br>
IBAN numbers for beneficiaries with accounts in Bahrain must be included in the payment instructions <br/></p>
<strong>Beneficiary bank </strong>
<p>Include SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/> 
SWIFT BIC is 8 or 11 alphanumeric characters: xxxxBHxx or xxxxBHxxxxx. </p>
<strong>Reason for payment</strong><br/>
A 3 letter Purpose of payment code is mandatory.<br>
<p>Where to include the information varies depending on how you submit the payment:<br>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong> ‘Beneficiary reference line 1’</strong>.<br>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>.<br>
<strong>Gem API:</strong> Reason for the payment should be populated in the <br>
<strong>&#60remittanceInformation&gt &#60unstructured&gt</strong>  field within the API request.<br>
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br>
<strong>&#60RmtInf&gt</strong><br>
<strong>&#60Ustrd&gt</strong><br>



</p>




</td><td>All</td></tr>


<tr><td>Canada</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
<p>The beneficiary full address.</p>
<p><strong>Beneficiary </strong></p>
<p>For all transactions in and out of Canada, including those paid through an intermediary bank, include account number, full name (no initials), full physical address (including Province), and telephone number of the beneficiary customer.<br/>
Use of initials may delay receipt of funds by the beneficiary.<br>
– When paying CAD to a beneficiary who holds an account with Royal Bank of Canada or the Bank of Nova Scotia, the account number should be 12 digits.<br>
– Telephone number of the beneficiary may also be provided in the beneficiary reference fields.
</p>
<p><strong>Beneficiary bank</strong></P>
<p>Provide the bank’s SWIFT BIC, and, where applicable, the Canadian Clearing Code for CAD payments. <br>
– It is recommended by Payments Canada that the Canadian Clearing Code or routing code be used for payments denominated in CAD. The 9-digit routing number is made up of the Direct Payment Routing Number (4 digits) and the Branch Transit Number (5 digits). The structure is //CC followed by nine digits. Example: //CC123412345.<br>
– Where applicable, the beneficiary bank address and/or transit number identifies which internal branch account the main bank should direct the funds to.<br>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxCAxx or xxxxCAxxxxx.
</p>
</td><td>All</td></tr>


<tr><td>China</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
The Chinese Renminbi is a restricted currency; Restricted currency payments must include all required information or they will be cancelled.<br>
One of 13 Reason for Payment codes to be included.<br/>
The beneficiary can not be an individual. They must be a company.<br/>
The full address of the beneficiary must be quoted. <br/>
When the payment is for goods or services, proof of trade is required e.g. invoice number, payment order number or a brief description.<br/><br/>
<p><strong>Beneficiary</strong></p>
Include account number, full name (no initials), address (the full address should include: house/room/floor number, street, city and country) , and as best practice, the telephone number of the beneficiary customer. Use of initials or beneficiary name mismatches may delay receipt of funds by the beneficiary.</br/>
– The provided beneficiary name should be exactly the same as the information registered in China’s central bank information system (RCPMIS)<br/><br/>
<p><strong>Beneficiary bank </strong></p>
Include the CNAPS code of the beneficiary bank (preferred). Input of the CNAPS code should start with the code word “C/N” followed by 12 digits. If not available, then include the SWIFT BIC and full name and address of the beneficiary bank. Failing to provide beneficiary bank name and address could result in payment mid-routing and delays.<br/>
– CNAPS is a 12/14-digit numeric code that identifies each CNAPS member bank. CNAPS is the renminbi RTGS clearing system in China. <br/>
– If SWIFT BIC is not available or the ordering customer is sending local currency within China, include the full name and address of the beneficiary bank.<br/>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxCNxx or xxxxCNxxxxx.<br/>
<strong>Reason for payment</strong><br/>
A purpose of payment code is mandatory and must be included for cross-border China-bound CNY payments. The purpose of payment code should be formatted as /ACC/PURPOSE/XXX or /ACC/XXX. Where XXX is the 3 letter code</br>
Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the <strong>'Instructions - Beneficiary Reference'</strong> section in <strong>‘Beneficiary reference line 1’.</strong><br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in ‘Beneficiary reference line 1’.<br/>
<strong>Gem API:</strong> Reason for the payment should be populated in the
&#60remittanceInformation&gt &#60unstructured&gt field within the API request.<br/>
<strong>Gem Direct: </strong>Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt </strong><br/>
<strong>&#60Ustrd&gt </strong><br/>


</td><td>All</td></tr>



<tr><td>Croatia</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
IBAN and SWIFT BIC are required for all euro payments. SEPA standards apply for euro payments to beneficiaries with accounts in Croatia.<br/>
<strong>Beneficiary</strong><br/>
Include account number (IBAN), full name (no initials) and address of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary.<br/>
<strong>Beneficiary bank </strong><br/>
Include SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/>
– There are no specific bank clearing codes for this country for cross-border payments; SWIFT BIC is key to routing payments to the beneficiary bank. <br/>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxHRxx or xxxxHRxxxxx.

</td><td>All</td></tr>


<tr><td>Fiji</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
FJD FX payments can only be made to on-shore residents hence the beneficiary full address is mandatory.<br/>
<strong>Beneficiary</strong><br/>
Include account number, branch name, full name (no initials) and address of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary.
You should provide a resident location for the beneficiary.  This data will be used by the beneficiary’s bank for regulatory reporting. Payments that don’t include this additional information could be returned by the beneficiary’s bank. <br/><br/>
<strong>Beneficiary bank</strong><br/>
Include SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxFJxx or xxxxFJxxxxx.<br/>
<strong>Reason for payment</strong><br/>
A reason for the payment is recommended. <br/><br/> 
<p>The format for the resident location and reason for payment looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/></p>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>

<tr><td>Georgia</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN <br/><br/>
<strong>Beneficiary</strong><br/>
Include account number (IBAN), full name (no initials) and address of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary.<br/>
– IBAN numbers for beneficiaries with accounts in Georgia must be included in the payment instructions.<br/>
<table>
<tr><td>Account # Ex</td><td>1234567891234567</td></tr>
<tr><td>Country code</td><td>GE</td></tr>
<tr><td>Structure</td><td>GE2!n2!a16!n</td></tr>
<tr><td>Length</td><td>22!c</td></tr>
<tr><td>Electronic format</td><td>GE98AB1234567891234567</td></tr>
<tr><td>Print Format Ex</td><td>GE98 AB12 3456 7891 2345 67</td></tr>
</table><br/>
<br/>
<strong>Beneficiary bank </strong><br/>
Include SWIFT BIC with branch identifier (where required), full name, and address of the 
beneficiary bank.<br/>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxGExx or xxxxGExxxxx.<br/><br/>
<strong>Reason for payment</strong><br/>
<p>The reason for the payment must be clearly identified (rent, salary, medical expenses, etc.).</p>


Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>


<tr><td>Greenland</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>


<tr><td>Iceland</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN <br/>
<strong>Beneficiary<br/></strong>
Include IBAN number, full name (no initials), and address of the beneficiary customer. <br/>
IBAN: 26characters (ISXX + 22 digits
    <p>
    <table>
<tr><td>Account # Ex</td><td>78 91234567891234</td></tr>
<tr><td>Country code</td><td>IS</td></tr>
<tr><td>Structure</td><td>4!n2!n6!n10!n</td></tr>
<tr><td>Length</td><td>26!c</td></tr>
<tr><td>Electronic format</td><td>IS981234567891234567891234</td></tr>
<tr><td>Print Format Ex</td><td>IS98 1234 5678 9123 4567 8912 34</td></tr>
</table>
 </p>
 <p>
 <strong>Beneficiary bank </strong><br/>
 Include SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/>
 – SWIFT BIC is 8 or 11 alphanumeric characters: xxxxISxx or xxxxISxxxxx.
 </p>
 <strong>Reason for payment</strong><br/>
 Purpose of payment is recommended. Any information that is vague/incomplete may need further clarification and result in payment delays.<br/>
 


Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>



<tr><td>India</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
<p>Payment Purpose Code (POP)- Reason for payment + Indian Financial System code</p>
<strong>Beneficiary details</strong><br/>
Include the full name, account number, address, and as best practice, telephone number of the beneficiary customer.<br/>
Beneficiary account type - select ‘Other’ to indicate the beneficiary’s account number is in a non-IBAN format<br/>
Beneficiary account number - this should be populated with the PAN (i.e. the beneficiary’s Indian account number).  The Account number <strong>must not</strong> contain dashes, spaces, or any other non-standard characters<br/>
<strong>Beneficiary bank details</strong><br/>
Do not include the Beneficiary bank SWIFT BIC. India does not use the SWIFT BIC network for domestic messaging. All payments must include the Indian Financial Services Code (IFSC) for electronic delivery of the payment.<br/>
Beneficiary bank code type - select ‘INFSC’ from the drop down</br>
Beneficiary bank code - enter the Indian bank’s 11-digit IFSC code</br>
Beneficiary bank name - this must be populated.  Include the beneficiary bank branch’s full name, address, including branch postal identification number (PIN), and branch telephone number (highly recommended).</br>
Country - select ‘India’ from the drop-down menu (these fields are Mandatory).</br>
<strong>Payment details – the reason for payment</strong><br/>
Payment purpose code is mandatory. Payments received without a specific purpose code will be cancelled and returned to the remitter.<br/>
If funds are being paid to a Charity – the Charity number and purpose of charity must be included <br/>
The relationship between remitter and beneficiary should be included (the LEI information) if the payment is greater than INR 500,000,000 <br/>
Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect International payment screen:</strong> The reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> The reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  The reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> The reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>Please note Indian Rupees (INR) can not be sent outside of India.</td></tr>

<tr><td>Iraq</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN <br/>
<strong>Beneficiary</strong><br/>
Individual to individual payments (P2P) are not permitted<br/>
Include account number (IBAN), full name (no initials) and address of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary.<br/>
– IBAN numbers for beneficiaries with accounts in Iraq must be included in the payment instructions

    <p>
    <table>
<tr><td>Account # Ex</td><td>123456789012</td></tr>
<tr><td>Country code</td><td>IQ</td></tr>
<tr><td>Structure</td><td>IQ2!n4!n3!n12!n</td></tr>
<tr><td>Length</td><td>23!c</td></tr>
<tr><td>Electronic format</td><td>IQ98NBIQ850123456789012</td></tr>
<tr><td>Print Format Ex</td><td>IQ98 NBIQ 8501 2345 6789 012</td></tr>
</table>
 </p>
 <p>
 <strong>Beneficiary bank </strong><br/>
 Include SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/>
 – SWIFT BIC is 8 or 11 alphanumeric characters: xxxxIQxx or xxxxIQxxxxx.
 </p>
 <strong>Reason for payment</strong><br/>
 Purpose of payment is recommended. <br/>
Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>



<tr><td>Ireland</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>EUR</td></tr>
<tr><td>Ireland</td><td>Full IBAN and BIC  required by AIB and BOI</td><td>GBP </td></tr>
<tr><td>Ireland</td><td>Minimum Sort Code and Account Number all other Banks</td><td>GBP</td></tr>
<tr><td>Israel</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN and BIC Code

<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>

<tr><td>Jamaica</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full beneficiary address<br/>
5 digit Transit Code<br/>
<strong>Beneficiary</strong><br/>
Include account number, where 5 digit Transit Code (Mandatory) must precede the 9 digit account number (14 digits in total). This is applicable to payments to all beneficiary banks. Include full name (no initials) and address (street address and city) of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary. <br/><br/>

<strong>Beneficiary bank</strong><br/>
Include SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxJMxx or xxxxJMxxxxx.<br/><br/>

<p><strong>Reason for payment</strong><br/>
Reason for payment is recommended. <br/>
Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong></p>

</td><td>All</td></tr>

<tr><td>Jordan</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN, Reason for payment and 4 Digit Code
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>Kuwait</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN and Payment Purpose Code (POP)
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Lebanon</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN and Reason for payment
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>Liechtenstein</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Macedonia</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>Mauritius</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Reason for payment
<p class='underline mb-0 mt-2'>Preferable</p>
IBAN</td><td>All</td></tr>
<tr><td>Mexico</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
18-digit account number required
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Moldova</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>Myanmar</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
POP (purpose of payment) code. This goes in the 'Instructions', 'Beneficiary Reference Line 1' field. You need to enter this as well as the reason for payment. Use the country specific code.
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>Pakistan</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
<p>Full beneficiary name, address<br/>
Full IBAN<br/>
Reason for payment<br/>
Beneficiary official identification number, e.g. passport number <br/>
Country name / code<br/>
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>Palestine</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>

<tr><td>Philippines</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
<p>A Purpose of Payment (POP) code is now mandatory for all payments to the Philippines.</p>

<p>A 10 digit Philippines POP code must be populated in <strong>‘Beneficiary reference line 1’</strong>, formatted as: 
/REG/XXXXXXXXXX
where XXXXXXXXXX is the POP code.</p>

<p>Some POP codes require more information – where necessary, this should be entered in <strong>‘Beneficiary reference line 2’</strong>.</p>
<p>The PoP codes are provided by the Central Bank of the Philippines; you need to include the code from the “inward” list.</p>
<p><strong>Beneficiary</strong><br/>
Include the beneficiary account number, full name (no initials) and address of the beneficiary customer.  Failure to provide full beneficiary customer details may result in delays or returns.<br/>
Avoid P.O. Box numbers and include street address, City, State, Country and postal code for the beneficiary’s address. 
</p>
<p>
<strong>Beneficiary bank</strong><br/>
Include SWIFT BIC with branch identifier (where required), full name and address of the beneficiary bank.<br/>
SWIFT BIC is 8 or 11 alphanumeric characters: xxxxPHxx or xxxxPHxxxxx.
</p>


</td><td>USD & GBP</td></tr>



<tr><td>Poland</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
Purpose of payment is recommended. <br/>
• Tax Payments must include additional details:<br/>
– NIP (Numer Identyfikacji Podatkowej) or REGON Rejestr Gospodarki Narodowej (Register of the National Economy) <br/>
• Period of time the payment is for <br/>
• Kind of tax being paid<br/>
Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>



<tr><td>Qatar</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Romania</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Saudi Arabia</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>

<tr><td>South Africa</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
<p>ZA Code (National Clearing Code) - typically 6 digits that identifies the bank and branch <br/></p>
<p><strong>Beneficiary</strong><br/>
Include account number, full name (no initials) and address of the beneficiary customer. Use of initials may delay receipt of funds by the beneficiary.
</p>
<p><strong>Beneficiary bank</strong><br/>
Include sort code, SWIFT BIC with branch identifier (where required), full name, and address of the beneficiary bank.<br/>
– The sort code should always be preceded with “//ZA” followed by the 6-digit bank code. Example: //ZA123456. <br/>
– SWIFT BIC is 8 or 11 alphanumeric characters: xxxxZAxx or xxxxZAxxxxx.
</p>
<p>
<strong>Reason for payment</strong><br/>
Reason for payment is recommended.<br/>
For Tax payments, include unique 19 character Payment Reference Number (PRN). Example: /PRN/xxxxxxxxxxxxxxxxxxx <br/>
Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</p>

</td><td>All</td></tr>
<tr><td>Switzerland</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Tunisia</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>
<tr><td>Turkey</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN
<p class='underline mb-0 mt-2'>Preferable</p>
You should provide a resident location for the beneficiary and a reason for the payment.  This will map to F70 on the MT103 message.  This data will be used by the beneficiary’s bank for regulatory reporting.  Payments that don’t include this additional information could be returned by the beneficiary’s bank.<br/>
The format for this additional data looks like this and should be entered as shown, including the forward slashes:<br/>
/BENEFRES/Country Code//reason for payment code or text<br/><br/>

‘BENEFRES’ always include this word first<br/>
‘Country code’ include the 2 digit ISO country code of the residency of the beneficiary<br/>
‘Reason for payment’ This is a code or text describing the reason for the payment<br/><br/>

Where to include the information varies depending on how you submit the payment:<br/>
<strong>Gem Connect UI:</strong> Reason for the payment goes in the 'Instructions - Beneficiary Reference' section in <strong>‘Beneficiary reference line 1’</strong>.<br/>
<strong>Gem Connect file import:</strong> Reason for the payment goes in <strong>‘Beneficiary reference line 1’</strong>. <br/>
<strong>Gem API:</strong>  Reason for the payment should be populated in the <br/>
<strong>&#60remittanceInformation&gt</strong> <strong>&#60unstructured&gt</strong> field within the API request.<br/> 
<strong>Gem Direct:</strong> Reason for the payment goes in line 1 of the unstructured remittance information block.<br/>
<strong>&#60RmtInf&gt</strong><br/>
<strong>&#60Ustrd&gt</strong>
</td><td>All</td></tr>

<tr><td>U S A</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Nothing specified <br/><br/>

<p><strong>Beneficiary</strong><br/>
Include account number, full name, and address of the beneficiary customer. <br/>
Use of initials can delay receipt of funds by the beneficiary.<br/>
– As best practice, beneficiary full name and account number must be included.<br/>
</p>
<p><strong>
Beneficiary bank </strong><br/>
Include ABA routing number (a 9 digit code that identifies the bank) or CHIPS participant code for the beneficiary bank (if available), SWIFT BIC, full name and address of the beneficiary bank. <br/>
– Include the SWIFT BIC to direct payments to the United States. <br/>
The receiving bank will then enter the payment into the domestic Federal Reserve (FED) clearing system. SWIFT BIC is 8 or 11 alphanumeric characters: xxxxUSxx or xxxxUSxxxxx.<br/>
– As best practice include beneficiary bank name and address


</p>

</td>
<td>All</td></tr>
<tr><td>Uganda</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Reason for payment
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td></tr>
<tr><td>United Arab Emirates</td><td><p class='underline mb-0'><strong>Mandatory details</strong></p>
Full IBAN & Payments to UAE also require a purpose for payment code
<p class='underline mb-0 mt-2'>Preferable</p>
Nothing specified</td><td>All</td>
</tr>
`;

export const appendixMandatoryCountryInfo = `<p><strong><i>Remitter should obtain all required bank information from the Beneficiary.</i></strong></p>
<table class='table table-bordered'>
<thead>
<tr>
<td>Country</td><td>Payment Information required</td><td>Currencies</td>
</tr>
</thead>
<tbody>
${table}
</tbody>
</table>`;



// WEBPACK FOOTER //
// ./src/components/content/appendices/3-mandatoryCountryInfo.ts